import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const FilesRoutes: RouteBundle = {
  domain: 'files',
  routes: [
    {
      urlPattern: ':currentUserUrl/files/:fileId',
      handler: EditorRoutes.fileEditor.bind(EditorRoutes),
    },
  ],
};
